import React from 'react';
import { connect } from 'react-redux';
import Icon from '@roo/roo/Icon';
import * as LX from '@utils/lxWrapper';
import pageJump from '@projects/Shell/utils/pageJump';
import { RootState } from '../../../../../store';
import { IBusinessStatus, BusinessStatus } from '../../../../../api/define';
import styles from './StatusTime.module.scss';

type StatusTimeProps = {
    businessStatusInfo: IBusinessStatus;
};

const { useCallback } = React;

const StatusTime: React.FC<StatusTimeProps> = ({ businessStatusInfo }) => {
    const { status, restType, shippingTimeDesc } = businessStatusInfo;

    const editHandle = useCallback(() => {
        LX.reportMC('b_waimai_e_vvmjq8uu_mc', 'c_waimai_e_fa4ps4ng', {
            // eslint-disable-next-line @typescript-eslint/camelcase
            is_delivery_temp_biz_hour_effective: businessStatusInfo.hasSpecialShippingTime,
        });
        pageJump.go('/v2/shop/manage/shopInfo');
    }, [businessStatusInfo]);

    return (
        <div className={styles.menuItem}>
            营业时间：{shippingTimeDesc}
            {status === BusinessStatus.REST &&
            (restType === undefined || restType === 0 || restType === 2) ? (
                ''
            ) : (
                <span className={styles.edit} onClick={editHandle}>
                    <Icon name="edit" size={12} />
                    编辑
                </span>
            )}
        </div>
    );
};

const mapStateToProps = (state: RootState) => {
    return {
        businessStatusInfo: state.shellHeader.poiBusinessStatus,
    };
};

export default connect(mapStateToProps)(StatusTime);
